/* Résultat d'un appel à une fonction Edge : renvoie `data`, ou lève une erreur portant le vrai
   message du serveur (corps JSON { error }), même en cas de réponse non-2xx. */
export async function edgeFunctionData({ data, error }, fallback = 'Erreur Jira') {
  if (error) {
    let msg = error.message || fallback;
    try {
      const body = await error.context?.json?.();
      if (body?.error) msg = body.error;
    } catch (_) {}
    throw new Error(msg);
  }
  if (data?.error) throw new Error(data.error);
  return data;
}
